/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListOrganicTrafficEvaluationsOptions,
  ListOrganicTrafficEvaluationsResponses,
} from '../types/ListOrganicTrafficEvaluations'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Every scoring tick is recorded, including the ones that left the order book's mode alone, so that the mode a book sat in can be explained by the figures behind it. Newest first. Every filter is optional and narrows the set.
 * @summary List organic activity score evaluations
 * {@link /v1/bots/organic-traffic/evaluations}
 */
export function listOrganicTrafficEvaluations<ThrowOnError extends boolean = true>(
  options: Options<ListOrganicTrafficEvaluationsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListOrganicTrafficEvaluationsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/bots/organic-traffic/evaluations',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListOrganicTrafficEvaluationsResponses, ThrowOnError>>,
  )
}
